import { getBlock, makeId, type ArticleBody } from "@louise/content";
import type { TranslationFunction } from "@src/packages/i18n";
import type { Article } from "../components/ArticleSectionCard";

const STIM_READINGS: { id: string; tagKey: string }[] = [
  { id: "new-article-stim-daily-tips", tagKey: "tag_daily_habits" },
];

function teaserFrom(subtitle: string | undefined, body: ArticleBody): string {
  const raw = subtitle ?? body.sections?.[0]?.content ?? "";
  return raw.length <= 80 ? raw : `${raw.slice(0, 77)}...`;
}

/**
 * Curated reading list for the active-stimulation Home surface. Same shape
 * as `getWaitStageReadings` — real block ids only, no fabricated content.
 */
export function getStimStageReadings(t: TranslationFunction): Article[] {
  const NS = "homepage.review_concept.stim_extras";
  return STIM_READINGS.flatMap(({ id, tagKey }) => {
    const block = getBlock(makeId(id));
    if (!block || block.kind !== "article") return [];
    const body = block.body as ArticleBody;
    return [
      {
        id: block.id,
        title: block.title,
        time: block.readTimeMinutes ? `${block.readTimeMinutes} min` : "",
        tag: t(`${NS}.${tagKey}`),
        teaser: teaserFrom(block.subtitle, body),
        body,
        tags: block.tags,
      },
    ];
  });
}
